<template>
  <header class="pn-header">

    <!-- TOP TRUST BAR -->
    <div class="pn-topbar">
      <div class="pn-container pn-topbar-inner">
        <div class="pn-trust-items">
          <span>
            <svg viewBox="0 0 24 24" fill="none">
              <path d="m5 12 4 4L19 6" />
            </svg>
            Livraison de pneus
          </span>

          <span>
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M4 18V6h16v12H4Zm4-12v12M16 6v12" />
            </svg>
            Solutions de montage
          </span>

          <span>
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" />
              <path d="m9 12 2 2 4-4" />
            </svg>
            Commande sécurisée
          </span>
        </div>

        <router-link to="/contact" class="pn-help-link">
          Besoin d'aide ?
          <strong>Contactez-nous</strong>
        </router-link>
      </div>
    </div>

    <!-- MAIN HEADER -->
    <div class="pn-main-header">
      <div class="pn-container pn-header-inner">

        <!-- MOBILE MENU BUTTON -->
        <button class="pn-mobile-toggle" type="button" :aria-expanded="mobileMenuOpen"
          aria-controls="pn-mobile-navigation" aria-label="Ouvrir le menu" @click="toggleMobileMenu">
          <svg v-if="!mobileMenuOpen" viewBox="0 0 24 24" fill="none">
            <path d="M4 6h16M4 12h16M4 18h16" />
          </svg>
          <svg v-else viewBox="0 0 24 24" fill="none">
            <path d="M5 5 19 19M19 5 5 19" />
          </svg>
        </button>

        <!-- BRAND -->
        <router-link to="/" class="pn-brand" aria-label="ProduPneu - Accueil" @click.native="closeMenus">
          <img src="/assets/images/Logo/logo.png" alt="ProduPneu.fr - Vente de pneus en ligne" class="pn-brand-logo" />
        </router-link>



        <!-- DESKTOP ADVANCED SEARCH -->
        <div class="pn-desktop-search">
          <NavbarSearch />
        </div>

        <!-- RIGHT ACTIONS -->
        <div class="pn-actions">

          <!-- ACCOUNT -->
          <div class="pn-account-wrapper">

            <button type="button" class="pn-header-action" :aria-expanded="accountMenuOpen"
              aria-controls="pn-account-menu" @click.stop="toggleAccountMenu">
              <span class="pn-action-icon">
                <svg viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="8" r="4" />
                  <path d="M4 21c0-4.4 3.3-7 8-7s8 2.6 8 7" />
                </svg>
              </span>

              <span class="pn-action-label">
                <strong>
                  {{ isAuthenticated ? userName : "Mon compte" }}
                </strong>
                <small>
                  {{ isAuthenticated ? "Mon espace" : "Se connecter" }}
                </small>
              </span>

              <svg class="pn-chevron" viewBox="0 0 24 24" fill="none">
                <path d="m6 9 6 6 6-6" />
              </svg>
            </button>

            <!-- ACCOUNT DROPDOWN -->
            <div v-if="accountMenuOpen" id="pn-account-menu" class="pn-account-dropdown">
              <template v-if="!isAuthenticated">
                <p class="pn-dropdown-title">Bienvenue sur ProduPneu</p>
                <p class="pn-dropdown-description">
                  Connectez-vous pour retrouver vos commandes.
                </p>

                <router-link to="/login" class="pn-dropdown-primary" @click.native="closeMenus">
                  Se connecter
                </router-link>

                <!-- <router-link to="/register" class="pn-dropdown-secondary" @click.native="closeMenus">
                  Créer un compte
                </router-link> -->
              </template>

              <template v-else>
                <div class="pn-user-welcome">
                  <span class="pn-user-avatar">
                    {{ userInitial }}
                  </span>

                  <div>
                    <strong>{{ userName }}</strong>
                    <small>{{ userEmail }}</small>
                  </div>
                </div>

                <div class="pn-dropdown-divider"></div>

                <router-link v-if="isAdmin" to="/admin" class="pn-dropdown-link" @click.native="closeMenus">
                  Tableau de bord admin
                </router-link>

                <template v-else>
                  <router-link to="/account" class="pn-dropdown-link" @click.native="closeMenus">
                    Mon compte
                  </router-link>

                  <router-link to="/my-orders" class="pn-dropdown-link" @click.native="closeMenus">
                    Mes commandes
                  </router-link>
                </template>

                <div class="pn-dropdown-divider"></div>

                <button type="button" class="pn-logout" :disabled="loggingOut" @click="logout">
                  {{ loggingOut ? "Déconnexion..." : "Se déconnecter" }}
                </button>
              </template>
            </div>
          </div>

          <!-- CART -->
          <router-link to="/cart" class="pn-header-action pn-cart-action" @click.native="closeMenus">
            <span class="pn-action-icon pn-cart-icon">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M3 4h2l2.5 12h11L21 8H6" />
                <circle cx="10" cy="20" r="1" />
                <circle cx="18" cy="20" r="1" />
              </svg>

              <span class="pn-cart-count">
                {{ cartCount > 99 ? "99+" : cartCount }}
              </span>
            </span>

            <span class="pn-action-label">
              <strong>Mon panier</strong>
              <small>{{ cartCount }} article{{ cartCount > 1 ? "s" : "" }}</small>
            </span>
          </router-link>

        </div>
      </div>
    </div>

    <!-- DESKTOP NAVIGATION -->
    <nav class="pn-navigation" aria-label="Navigation principale">
      <div class="pn-container pn-nav-inner">

        <router-link to="/products" class="pn-nav-link pn-nav-primary" @click.native="closeMenus">
          <svg viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="9" />
            <circle cx="12" cy="12" r="4" />
            <path d="M12 3v5M12 16v5M3 12h5M16 12h5" />
          </svg>
          Tous les pneus
        </router-link>

        <router-link to="/brands" class="pn-nav-link" @click.native="closeMenus">
          Nos marques
        </router-link>

        <router-link to="/products?season=summer" class="pn-nav-link" @click.native="closeMenus">
          Pneus été
        </router-link>

        <router-link to="/products?season=winter" class="pn-nav-link" @click.native="closeMenus">
          Pneus hiver
        </router-link>

        <router-link to="/products?season=all-season" class="pn-nav-link" @click.native="closeMenus">
          Pneus 4 saisons
        </router-link>

        <router-link to="/delivery" class="pn-nav-link" @click.native="closeMenus">
          Livraison
        </router-link>

        <router-link to="/contact" class="pn-nav-link" @click.native="closeMenus">
          Contact
        </router-link>

        <router-link to="/products" class="pn-nav-promo" @click.native="closeMenus">
          Découvrir nos pneus
          <span>→</span>
        </router-link>
      </div>
    </nav>

    <!-- MOBILE / TABLET ADVANCED SEARCH -->
    <div class="pn-mobile-search">
      <div class="pn-mobile-search-container">
        <NavbarSearch />
      </div>
    </div>

    <!-- MOBILE NAVIGATION -->
    <nav v-if="mobileMenuOpen" id="pn-mobile-navigation" class="pn-mobile-navigation" aria-label="Navigation mobile">
      <router-link v-for="item in mobileLinks" :key="item.label" :to="item.to" @click.native="closeMenus">
        {{ item.label }}
        <span>→</span>
      </router-link>

      <div class="pn-mobile-nav-bottom">
        <router-link :to="isAuthenticated ? (isAdmin ? '/admin' : '/account') : '/login'" @click.native="closeMenus">
          {{ isAuthenticated ? "Mon espace" : "Connexion / Inscription" }}
        </router-link>
      </div>
    </nav>

  </header>
</template>

<script>
import NavbarSearch from "./NavbarSearch.vue";
export default {
  name: "Navbar",
  components: {
    NavbarSearch,
  },

  data() {
    return {
      searchQuery: "",
      mobileMenuOpen: false,
      accountMenuOpen: false,
      loggingOut: false,

      mobileLinks: [
        { label: "Accueil", to: "/" },
        { label: "Tous les pneus", to: "/products" },
        { label: "Nos marques", to: "/brands" },
        { label: "Pneus été", to: "/products?season=summer" },
        { label: "Pneus hiver", to: "/products?season=winter" },
        { label: "Pneus 4 saisons", to: "/products?season=all-season" },
        { label: "Livraison", to: "/delivery" },
        { label: "Contact", to: "/contact" },
      ],
    };
  },

  computed: {
    isAuthenticated() {
      return this.$store.getters["auth/isAuthenticated"] || false;
    },

    isAdmin() {
      return this.$store.getters["auth/isAdmin"] || false;
    },

    user() {
      return this.$store.state.auth.user || {};
    },

    userName() {
      const name = this.user.name || "Mon compte";
      return name.split(" ")[0];
    },

    userEmail() {
      return this.user.email || "";
    },

    userInitial() {
      return this.userName.charAt(0).toUpperCase();
    },

    cartCount() {
      const cart = this.$store.state.cart;

      if (!cart || !Array.isArray(cart.items)) {
        return 0;
      }

      return cart.items.reduce((total, item) => {
        return total + Number(item.quantity || 0);
      }, 0);
    },
  },

  watch: {
    "$route.fullPath"() {
      this.closeMenus();
    },
  },

  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
    document.addEventListener("keydown", this.handleEscape);
  },

  beforeDestroy() {
    document.removeEventListener("click", this.handleOutsideClick);
    document.removeEventListener("keydown", this.handleEscape);
  },

  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      this.accountMenuOpen = false;
    },

    toggleAccountMenu() {
      this.accountMenuOpen = !this.accountMenuOpen;
      this.mobileMenuOpen = false;
    },

    closeMenus() {
      this.mobileMenuOpen = false;
      this.accountMenuOpen = false;
    },

    handleOutsideClick(event) {
      if (!this.$el.contains(event.target)) {
        this.closeMenus();
        return;
      }

      if (
        this.accountMenuOpen &&
        !event.target.closest(".pn-account-wrapper")
      ) {
        this.accountMenuOpen = false;
      }
    },

    handleEscape(event) {
      if (event.key === "Escape") {
        this.closeMenus();
      }
    },

    submitSearch() {
      if (!this.searchQuery) return;

      this.closeMenus();

      this.$router.push({
        path: "/products",
        query: {
          search: this.searchQuery,
        },
      }).catch((error) => {
        if (error.name !== "NavigationDuplicated") {
          console.error(error);
        }
      });
    },

    async logout() {
      if (this.loggingOut) return;

      this.loggingOut = true;

      try {
        await this.$store.dispatch("auth/logout");

        this.closeMenus();

        if (this.$route.path !== "/") {
          await this.$router.push("/");
        }
      } catch (error) {
        console.error("Logout failed:", error);
      } finally {
        this.loggingOut = false;
      }
    },
  },
};
</script>

<style scoped>
/* ========================================
   PRODU PNEU - NEW HEADER DESIGN
======================================== */

.pn-header {
  --pn-orange: #ff7900;
  --pn-orange-hover: #ef6800;
  --pn-dark: #15191d;
  --pn-text: #24282d;
  --pn-muted: #81868c;
  --pn-border: #e9ecef;

  position: sticky;
  top: 0;
  z-index: 1100;

  width: 100%;
  background: #fff;
  color: var(--pn-text);
  font-family: "Poppins", sans-serif;

  box-shadow: 0 3px 16px rgba(0, 0, 0, 0.06);
}

.pn-header *,
.pn-header *::before,
.pn-header *::after {
  box-sizing: border-box;
}

.pn-header button {
  font-family: inherit;
}

.pn-header svg {
  width: 21px;
  height: 21px;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.pn-container {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 32px;
}

/* TOP BAR */

.pn-topbar {
  background: var(--pn-dark);
  color: #dce0e4;
  font-size: 11px;
}

.pn-topbar-inner {
  min-height: 35px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.pn-trust-items {
  display: flex;
  align-items: center;
  gap: 25px;
}

.pn-trust-items span {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  white-space: nowrap;
}

.pn-trust-items svg {
  width: 14px;
  height: 14px;
  color: var(--pn-orange);
}

.pn-help-link {
  color: #e0e2e5;
  white-space: nowrap;
  text-decoration: none;
}

.pn-help-link strong {
  color: #fff;
  margin-left: 6px;
}

.pn-help-link:hover {
  color: var(--pn-orange);
}

/* MAIN HEADER */

.pn-main-header {
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
}

.pn-header-inner {
  min-height: 90px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 36px;
}

/* LOGO */

.pn-brand {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  text-decoration: none !important;
  line-height: 1;
}

.pn-brand-name {
  font-size: 33px;
  font-weight: 900;
  font-style: italic;
  color: #17191c;
  letter-spacing: -1.7px;
}

.pn-brand-name>span {
  color: var(--pn-orange);
}

.pn-brand-name small {
  font-size: 13px;
  letter-spacing: -0.3px;
  color: #4b4b4b;
}

.pn-brand-tagline {
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 1.5px;
  color: #777;
  margin-top: 7px;
}

/* SEARCH */

.pn-search {
  flex: 1;
  display: flex;
  align-items: center;
  max-width: 580px;
  min-width: 0;
  height: 50px;
  background: #f5f6f7;
  border: 1px solid transparent;
  border-radius: 10px;
  overflow: hidden;
  transition: 0.2s ease;
  margin: 0;
}

.pn-search:focus-within {
  background: #fff;
  border-color: var(--pn-orange);
  box-shadow: 0 0 0 3px rgba(255, 121, 0, 0.09);
}

.pn-search input {
  flex: 1;
  min-width: 0;
  height: 100%;
  padding: 0 18px;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--pn-text);
  font-size: 12px;
}

.pn-search input::placeholder {
  color: #92969a;
}

.pn-search-button {
  flex-shrink: 0;
  width: 53px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 0;
  color: var(--pn-dark);
  cursor: pointer;
}

.pn-search-button:hover {
  color: var(--pn-orange);
}

/* ACTIONS */

.pn-actions {
  display: flex;
  align-items: center;
  gap: 28px;
  flex-shrink: 0;
}

.pn-account-wrapper {
  position: relative;
}

.pn-header-action {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 0;
  border: 0;
  background: transparent;
  text-decoration: none !important;
  color: var(--pn-dark);
  cursor: pointer;
  white-space: nowrap;
}

.pn-header-action:hover {
  color: var(--pn-orange);
}

.pn-action-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--pn-dark);
}

.pn-action-icon svg {
  width: 27px;
  height: 27px;
}

.pn-action-label {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.45;
}

.pn-action-label strong {
  font-size: 12px;
  font-weight: 700;
}

.pn-action-label small {
  color: var(--pn-muted);
  font-size: 10px;
}

.pn-chevron {
  width: 14px !important;
  height: 14px !important;
  color: #999;
}

.pn-cart-icon {
  position: relative;
  color: var(--pn-orange);
}

.pn-cart-count {
  position: absolute;
  top: -9px;
  right: -12px;
  min-width: 19px;
  height: 19px;
  padding: 0 3px;
  background: var(--pn-orange);
  border-radius: 50px;
  border: 2px solid #fff;
  font-size: 9px;
  font-weight: 800;
  line-height: 15px;
  text-align: center;
  color: #fff;
}

/* DESKTOP MENU */

.pn-navigation {
  height: 52px;
  background: #fff;
  box-shadow: 0 5px 14px rgba(0, 0, 0, 0.045);
}

.pn-nav-inner {
  display: flex;
  align-items: stretch;
  height: 100%;
  gap: 30px;
}

.pn-nav-link {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 100%;
  color: #30353a;
  font-size: 12px;
  font-weight: 650;
  white-space: nowrap;
  text-decoration: none !important;
  border-bottom: 3px solid transparent;
  transition: 0.2s ease;
}

.pn-nav-link:hover,
.pn-nav-link.router-link-exact-active {
  color: var(--pn-orange);
  border-bottom-color: var(--pn-orange);
}

.pn-nav-primary {
  font-weight: 750;
}

.pn-nav-primary svg {
  color: var(--pn-orange);
  width: 18px;
  height: 18px;
}

.pn-nav-promo {
  display: flex;
  align-items: center;
  margin-left: auto;
  color: var(--pn-orange);
  text-decoration: none !important;
  font-weight: 800;
  font-size: 12px;
  white-space: nowrap;
  gap: 8px;
}

.pn-nav-promo:hover {
  color: var(--pn-orange-hover);
}

/* ACCOUNT DROPDOWN */

.pn-account-dropdown {
  position: absolute;
  top: calc(100% + 18px);
  right: 0;
  width: 290px;
  padding: 22px;
  background: #fff;
  border: 1px solid var(--pn-border);
  border-radius: 14px;
  box-shadow: 0 18px 55px rgba(17, 23, 31, 0.15);
  z-index: 1010;
}

.pn-dropdown-title {
  font-size: 15px;
  font-weight: 800;
  color: #202428;
  margin-bottom: 8px;
}

.pn-dropdown-description {
  font-size: 12px;
  line-height: 1.7;
  color: #73777b;
  margin-bottom: 18px;
}

.pn-dropdown-primary,
.pn-dropdown-secondary {
  display: block;
  width: 100%;
  text-align: center;
  padding: 12px;
  border-radius: 8px;
  text-decoration: none !important;
  font-size: 12px;
  font-weight: 800;
}

.pn-dropdown-primary {
  background: var(--pn-orange);
  color: #fff !important;
}

.pn-dropdown-secondary {
  border: 1px solid #ddd;
  color: #333 !important;
  margin-top: 9px;
}

.pn-user-welcome {
  display: flex;
  gap: 12px;
  align-items: center;
}

.pn-user-avatar {
  width: 43px;
  height: 43px;
  border-radius: 50%;
  background: #fff0df;
  color: var(--pn-orange);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
}

.pn-user-welcome div {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.pn-user-welcome strong {
  font-size: 13px;
}

.pn-user-welcome small {
  font-size: 11px;
  color: #888;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pn-dropdown-divider {
  height: 1px;
  background: #ededed;
  margin: 15px 0;
}

.pn-dropdown-link {
  display: block;
  padding: 9px 0;
  color: #303030;
  font-size: 12px;
  text-decoration: none !important;
}

.pn-dropdown-link:hover {
  color: var(--pn-orange);
}

.pn-logout {
  width: 100%;
  background: #fff1eb;
  color: #d94724;
  border: 0;
  border-radius: 7px;
  padding: 11px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
}

/* MOBILE ELEMENTS */

.pn-mobile-toggle,
.pn-mobile-search,
.pn-mobile-navigation {
  display: none;
}

/* TABLET */

@media (max-width: 1199px) {
  .pn-container {
    padding: 0 22px;
  }

  .pn-header-inner {
    gap: 18px;
  }

  .pn-brand-name {
    font-size: 28px;
  }

  .pn-actions {
    gap: 17px;
  }

  .pn-nav-inner {
    gap: 19px;
  }

  .pn-nav-link,
  .pn-nav-promo {
    font-size: 11px;
  }

  .pn-action-label {
    display: none;
  }

  .pn-chevron {
    display: none;
  }
}

/* MOBILE */

@media (max-width: 991px) {
  .pn-topbar {
    display: none;
  }

  @media (max-width: 991px) {
    .pn-navigation {
      display: none;
    }
  }

  .pn-header-inner {
    min-height: 74px;
    gap: 15px;
  }

  .pn-mobile-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border: 0;
    background: transparent;
    color: var(--pn-dark);
    padding: 4px;
    cursor: pointer;
  }

  .pn-mobile-toggle svg {
    width: 27px;
    height: 27px;
  }

  /* .pn-brand {
    margin-right: auto;
  } */

  .pn-brand-name {
    font-size: 26px;
  }

  .pn-brand-tagline {
    font-size: 6px;
  }

  .pn-actions {
    gap: 18px;
  }

  .pn-action-icon svg {
    width: 25px;
    height: 25px;
  }

  .pn-mobile-search {
    display: block;
    padding: 0 22px 14px;
    background: #fff;
  }

  .pn-mobile-search form {
    display: flex;
    height: 47px;
    background: #f4f5f6;
    border: 1px solid #eee;
    border-radius: 9px;
    overflow: hidden;
    margin: 0;
  }

  .pn-mobile-search input {
    flex: 1;
    min-width: 0;
    padding: 0 14px;
    border: 0;
    outline: none;
    background: transparent;
    font-size: 12px;
  }

  .pn-mobile-search button {
    width: 48px;
    border: 0;
    background: var(--pn-orange);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .pn-mobile-navigation {
    display: block;
    background: #fff;
    padding: 12px 22px 23px;
    border-top: 1px solid #eee;
    box-shadow: 0 15px 25px rgba(0, 0, 0, .07);
  }

  .pn-mobile-navigation>a {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 13px 5px;
    border-bottom: 1px solid #f2f2f2;
    font-size: 13px;
    color: #25282d;
    font-weight: 650;
    text-decoration: none;
  }

  .pn-mobile-navigation>a span {
    color: var(--pn-orange);
  }

  .pn-mobile-nav-bottom {
    margin-top: 15px;
  }

  .pn-mobile-nav-bottom a {
    display: block;
    background: var(--pn-orange);
    text-align: center;
    color: #fff;
    padding: 13px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 800;
  }
}

/* SMALL PHONES */

@media (max-width: 480px) {
  .pn-container {
    padding: 0 15px;
  }

  .pn-header-inner {
    gap: 9px;
    min-height: 67px;
  }

  .pn-brand-name {
    font-size: 23px;
  }

  .pn-brand-tagline {
    font-size: 5px;
    letter-spacing: 0.8px;
  }

  .pn-actions {
    gap: 13px;
  }

  .pn-mobile-search {
    padding: 15px 12px;
  }

  .pn-account-dropdown {
    position: fixed;
    top: 68px;
    right: 12px;
    width: min(290px, calc(100vw - 24px));
  }

  .pn-cart-count {
    top: -7px;
    right: -8px;
  }
}

.pn-brand {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
  text-decoration: none !important;
}

.pn-brand-logo {
  display: block;
  width: 190px;
  height: 80px;
  object-fit: contain;
  object-position: left center;
  transition: transform 0.3s ease;
}

.pn-brand:hover .pn-brand-logo {
  transform: scale(1.03);
}

@media (max-width: 1199px) {
  .pn-brand-logo {
    width: 165px;
    height: 60px;
  }
}

@media (max-width: 768px) {
  .pn-brand-logo {
    width: 145px;
    height: 54px;
  }
}

@media (max-width: 480px) {
  .pn-brand-logo {
    width: 125px;
    height: 46px;
  }
}

.pn-search-area {
  flex: 1 1 380px;
  width: 100%;
  min-width: 0;
  max-width: 570px;
  position: relative;
  z-index: 100;
}

@media (max-width: 767px) {
  .pn-search-area {
    flex: 1 1 100%;
    max-width: 100%;
  }
}

/* =============================================
   PRODUPNEU - RESPONSIVE ADVANCED SEARCH
============================================= */

/* Desktop */

.pn-desktop-search {
  display: block;
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  max-width: 570px;
  position: relative;
  z-index: 1050;
}

.pn-mobile-search {
  display: none;
}

/* Tablet */

@media (max-width: 1199px) {
  .pn-header-inner {
    gap: 16px;
  }

  .pn-desktop-search {
    max-width: 420px;
  }
}

/* Tablet + Mobile */

@media (max-width: 991px) {
  .pn-header-inner {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    min-height: 76px;
  }

  /* Hide search in main header */
  .pn-desktop-search {
    display: none;
  }

  /* Show second-row search */
  .pn-mobile-search {
    display: block;
    position: relative;
    z-index: 1040;
    width: 100%;
    padding: 0 22px 15px;
    background: #fff;
    border-bottom: 1px solid #edf0f2;
  }

  .pn-mobile-search-container {
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
  }

  .pn-mobile-search :deep(.pns-wrapper) {
    width: 100%;
  }

  .pn-mobile-search :deep(.pns-form) {
    display: flex;
    width: 100%;
    height: 50px;
    border-radius: 10px;
    background: #f5f7f9;
  }

  .pn-mobile-search :deep(.pns-form input) {
    font-size: 13px;
    padding-left: 43px;
  }

  .pn-mobile-search :deep(.pns-dropdown) {
    width: 100%;
    min-width: 0;
    max-height: min(560px, 65vh);
    left: 0;
    right: 0;
    z-index: 1100;
  }
}

/* Small mobile */

@media (max-width: 575px) {
  .pn-header-inner {
    min-height: 69px;
    gap: 8px;
  }

  .pn-mobile-search {
    padding: 15px 13px;
  }

  .pn-mobile-search :deep(.pns-form) {
    height: 47px;
  }

  .pn-mobile-search :deep(.pns-form input) {
    font-size: 12px;
  }

  .pn-mobile-search :deep(.pns-dropdown) {
    max-height: 60vh;
  }

  .pn-brand-logo {
    width: 125px;
    height: 46px;
  }

  .pn-actions {
    gap: 12px;
  }

  .pn-action-icon svg {
    width: 23px;
    height: 23px;
  }
}

/* Very small phones */

@media (max-width: 360px) {
  .pn-brand-logo {
    width: 105px;
    height: 42px;
  }

  .pn-header-inner {
    gap: 5px;
  }

  .pn-actions {
    gap: 8px;
  }

  .pn-mobile-search {
    padding-left: 12px;
    padding-right: 12px;
  }
}

/* ==========================================
   PRODUPNEU - STICKY RESPONSIVE NAVBAR
========================================== */

/* Desktop */
.pn-header {
  position: sticky;
  top: 0;
  z-index: 1100;

  width: 100%;
  background: #fff;

  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.07);
}

/* Keep dropdown menus above page content */
.pn-account-dropdown {
  z-index: 1200;
}

.pn-desktop-search {
  z-index: 1150;
}

/* Tablet and mobile */
@media (max-width: 991px) {
  .pn-header {
    position: sticky;
    top: 0;
    z-index: 1100;
  }

  .pn-mobile-search {
    position: relative;
    z-index: 1101;
  }

  /* Scroll inside the mobile menu if needed */
  .pn-mobile-navigation {
    max-height: calc(100dvh - 135px);
    overflow-y: auto;
    overscroll-behavior: contain;
  }
}

/* Small mobile */
@media (max-width: 575px) {
  .pn-header {
    top: 0;
  }

  .pn-mobile-navigation {
    max-height: calc(100dvh - 130px);
  }
}

</style>
